import clsx from "clsx";

import { handleAssetUrl } from "../../../shared/utils";

export function QuestionHeader({
  questionBrand,
  isArcade,
}: {
  questionBrand: string;
  isArcade?: boolean;
}) {
  return (
    <div className={clsx("quiz--question__header", isArcade && "quiz-question-arcade--header")}>
      <div className="question__header--label">
        {isArcade ? (
          "ANSWER THE QUESTIONS TO WIN POINTS YOU CAN REDEEM FOR PRIZES!"
        ) : window.FKL.shouldDoublePoints ? (
          <>
            BONUS: DOUBLE YOUR QUIZ ENTRIES WHEN YOU FINISH THE QUIZ!{" "}
            {[...Array(3)].map((_, i) => (
              <img
                key={`question__header--label-icon-${i}`}
                src={handleAssetUrl("fire_icon.png")}
                className="question__header--label-icon"
                alt="Double Points Icon"
              />
            ))}
          </>
        ) : (
          "COMPLETE THE QUIZ TO CLAIM THE SWEEP ENTRIES:"
        )}
      </div>
      {!isArcade && (
        <div className="question__header--brand">{questionBrand}</div>
      )}
    </div>
  );
}
